import React from 'react';

import { GetAcademicYearStartMonth, GetAcademicYearOffset } from '../util/Config';

export default function AcademicYear(props) {
	if (typeof props === 'undefined') {
		return null;
	}

	const startMonth = GetAcademicYearStartMonth();
	const offSet = GetAcademicYearOffset();
	const academicYear = props.children || props;

	if (typeof academicYear === 'undefined' || academicYear.children === 'undefined') {
		return null;
	}

	if (!parseInt(academicYear, 10)) {
		return academicYear;
	}

	if (startMonth === 1) {
		return academicYear + offSet;
	}

	return `${parseInt(academicYear, 10) + offSet} / ${parseInt(academicYear, 10) + offSet + 1}`;
}
